import { gql } from '@apollo/client'

export const SearchAddressFragment = gql`
  fragment SearchAddressItem on SearchAddressItem {
    description
    highlight
    id
    text
    type
  }
`

export const SearchAddressResponseFragment = gql`
  ${SearchAddressFragment}
  fragment SearchAddressResponse on SearchAddressResponse {
    items {
      ...SearchAddressItem
    }
  }
`

export const RetrieveAddressFragment = gql`
  fragment RetrieveAddressItem on RetrieveAddressItem {
    city
    countryName
    district
    id
    label
    line1
    line2
    line3
    postalCode
    province
    type
  }
`
